import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Capacitor } from '@capacitor/core'
import { useAuthStore } from '../stores/authStore'
import api from '../services/api'

export default function ChangePassword() {
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const { user, setAuth, accessToken, refreshToken } = useAuthStore()
  const navigate = useNavigate()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    if (next !== confirm) { setError('Passwords do not match'); return }
    if (next.length < 8) { setError('Password must be at least 8 characters'); return }
    setLoading(true)
    try {
      await api.post('/auth/change-password', { currentPassword: current, newPassword: next })
      // Update local user state so mustChangePassword is cleared
      if (user) {
        setAuth(accessToken!, refreshToken!, { ...user, mustChangePassword: false })
      }
      navigate(Capacitor.isNativePlatform() ? '/m/home' : '/dashboard', { replace: true })
    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to change password')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: 'var(--bg)' }}>
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src="/logo-mark.svg" alt="HSEQ Intelligence" className="mx-auto mb-4" style={{ width: 72, height: 72 }} />
          <h1 className="text-3xl font-extrabold tracking-tight" style={{ color: 'var(--brand-navy)' }}>
            hseq<span className="font-medium" style={{ color: 'var(--text-secondary)' }}> intelligence</span>
          </h1>
        </div>

        <div className="card">
          <div style={{ marginBottom: 24 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
              <div style={{ width: 36, height: 36, borderRadius: 10, background: 'rgba(37,99,235,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2.5"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
              </div>
              <div>
                <div className="font-bold" style={{ color: 'var(--text)', fontSize: 16 }}>Set your password</div>
                <div style={{ color: 'var(--text-muted)', fontSize: 13 }}>You're using a temporary password — set a new one to continue</div>
              </div>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label>Temporary password</label>
              <input
                type="password"
                value={current}
                onChange={e => setCurrent(e.target.value)}
                required
                autoComplete="current-password"
                placeholder="Enter the password from your welcome email"
              />
            </div>
            <div>
              <label>New password</label>
              <input
                type="password"
                value={next}
                onChange={e => setNext(e.target.value)}
                required
                autoComplete="new-password"
                placeholder="At least 8 characters"
              />
            </div>
            <div>
              <label>Confirm new password</label>
              <input
                type="password"
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                required
                autoComplete="new-password"
                placeholder="Repeat your new password"
              />
            </div>

            {error && (
              <div className="text-sm p-3 rounded-lg" style={{ background: 'var(--red-light)', color: 'var(--red)' }}>
                {error}
              </div>
            )}

            <button type="submit" className="btn btn-primary w-full justify-center" disabled={loading}>
              {loading ? 'Saving...' : 'Set password & continue →'}
            </button>
          </form>

          <p className="text-xs text-center mt-4" style={{ color: 'var(--text-muted)' }}>
            Signed in as <strong>{user?.email}</strong>
          </p>
        </div>

        <p className="text-center text-xs mt-4" style={{ color: 'var(--text-muted)' }}>
          Data stored in Australia (AWS ap-southeast-2)
        </p>
      </div>
    </div>
  )
}
